<script setup lang="ts">

</script>

<template>
  <div class="content-column">
    <div v-if="$slots.left?.({})" class="column-left">
      <slot name="left" />
    </div>
    <div class="column-main">
      <slot />
    </div>
    <div v-if="$slots.right?.({})" class="column-right">
      <slot name="right" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.content-column {
  @include screen.gridContainer();
}
.column-main {
  @include screen.grid(4 / span 6, 8, 4);
}
.column-left {
  @include screen.grid(3, 8, 4);
}
.column-right {
  @include screen.grid(10 / span 3, 8, 4);
}
</style>
